/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { flattenDeep, values } from 'lodash';

export const objectToFlattenArray = (obj: any) => flattenDeep(values(obj));
